import { type Trailer } from "@filmweb/sanity-types";
import classNames from "classnames";
import { useState } from "react";
import TrailerPlayer from "src/components/film/TrailerPlayer";
import withWatchlist from "src/components/filmwebid/withWatchlist";
import OverlayPortal from "src/components/overlayportal/OverlayPortal";
import CustomizablePoster from "src/components/posterrow/CustomizablePoster";
import PlaySvg from "src/components/svg/PlaySvg";
import { type IFilmomtale } from "src/lib/types/Filmomtale";
import styles from "./PosterWithFloatingTrailerButton.module.css";

//#region [Props]
type PosterWithFloatingPosterButtonProps = {
    film: IFilmomtale;
    className?: string;
    hideKinoklubb?: boolean;
};
//#endregion

//#region [Component]
const WLCustomizablePoster = withWatchlist(CustomizablePoster, "film");

export default function PosterWithFloatingPosterButton({ film, className, hideKinoklubb = false }: PosterWithFloatingPosterButtonProps) {
    const [isShowingOverlay, setShowOverlay] = useState(false);

    const trailer = (film.trailersOverride?.[0] ?? film.trailers?.[0]) as (Trailer | undefined | null);
    return <>
        <WLCustomizablePoster film={film} width={200} className={styles.PosterWithFloatingPosterButton} wlcClassName={className} hideKinoklubbBanner={hideKinoklubb}>
            {trailer && <TrailerButton onClick={() => setShowOverlay(true)} />}
        </WLCustomizablePoster>
        {isShowingOverlay && <OverlayPortal doClose={() => setShowOverlay(false)}>
            <div className={styles.TrailerAligner}>
                <TrailerPlayer trailerId={trailer?.videoId} />
            </div>
        </OverlayPortal>}</>

}
//#endregion

//#region [Component]
function TrailerButton({ onClick }: { onClick: () => void; }) {
    return <button className={styles.TrailerButton} onClick={onClick}><PlaySvg /></button>;
}
//#endregion